module.exports = __webpack_public_path__ + "static/media/icon_bc_doanhthu.eb7c66f9.svg";